'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_motors_ld', {
      url: '/tvs_motors_ld',
      template: '<tvsmotorsldtab></tvsmotorsldtab>',
      authenticate: 'admin'
    });
}
